import React, { useState, useEffect, useCallback } from 'react';
import * as Sentry from '@sentry/react';
import { t } from 'ttag';
import qs from 'qs';
import clsx from 'clsx';

import { RiHeartFill, RiHeartLine } from 'react-icons/ri';

import Modal from 'js/Account/Login/Modals/Modal';
import client from 'utils/client';
import { useIsAuthenticated } from 'hooks';

const addToFavorite = props => {
  const [isFavourited, setIsFavourited] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const { isAuthenticated } = useIsAuthenticated();

  useEffect(() => {
    const fetchFavorites = async () => {
      const hasFavourited = await props.favorites.find(
        fav => parseInt(fav.id, 10) === parseInt(props.productId, 10)
      );
      setIsFavourited(hasFavourited);
    };

    fetchFavorites();
  }, [props.productId, props.favorites]);

  const handleFavouriteClick = useCallback(
    productID => {
      if (isAuthenticated) {
        const postUrl = isFavourited
          ? '/api/favorites/remove/'
          : '/api/favorites/add/';

        client
          .post(postUrl, qs.stringify({ product_id: productID }))
          .then(() => {});

        setIsFavourited(!isFavourited);
      } else {
        setShowLoginModal(true);
      }
    },
    [isAuthenticated, isFavourited]
  );

  return (
    <>
      <button
        type="button"
        onClick={() => handleFavouriteClick(props.productId)}
        aria-label={t`Add Product to Favourites`}
        className={clsx(
          'm-0 border-0 bg-transparent p-0 hover:cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          {
            'text-black': isFavourited,
            'text-dark-gray hover:text-black': !isFavourited
          }
        )}
      >
        {isFavourited ? (
          <RiHeartFill className="h-6 w-6" />
        ) : (
          <RiHeartLine className="h-6 w-6" />
        )}
      </button>
      <Sentry.ErrorBoundary fallback={null}>
        <Modal
          isOpen={showLoginModal}
          onClose={() => {
            setShowLoginModal(false);
          }}
          modal="login"
          loginHeading={t`Please log in to add products to your favorite list.`}
          signupSource="pdp_favorite"
        />
      </Sentry.ErrorBoundary>
    </>
  );
};
export default addToFavorite;
